import { FC } from 'react';
import { Flex, FlexProps } from 'antd';
import styled from 'styled-components';
import { lineHeight } from '@atlas-frontend/design-tokens';
import { TextEllipsis } from '../../components/TextEllipsis';
import { TextSecondary } from '../../components/typography';

export interface FormSelectSelectionLabelProps extends FlexProps {
  supertitle?: string;
  ellipsis?: boolean;
}

export const FormSelectSelectionLabel: FC<FormSelectSelectionLabelProps> = (
  props
) => {
  const { supertitle, ellipsis, children, ...rest } = props;

  return (
    <StyledFlex vertical {...rest}>
      {supertitle &&
        (ellipsis ? (
          <TextSecondary>
            <TextEllipsis>
              <small>{supertitle}</small>
            </TextEllipsis>
          </TextSecondary>
        ) : (
          <TextSecondary>
            <small>{supertitle}</small>
          </TextSecondary>
        ))}
      {ellipsis ? <TextEllipsis>{children}</TextEllipsis> : children}
    </StyledFlex>
  );
};

const StyledFlex = styled(Flex)`
  line-height: ${lineHeight};

  [class*='select-selection'] & {
    padding-block: 4px;
  }
`;
